/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Feature_Job_TrackingInputs */

const en_settings_feature_job_tracking = /** @type {(inputs: Settings_Feature_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job tracking`)
};

const de_settings_feature_job_tracking = /** @type {(inputs: Settings_Feature_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellen-Tracking`)
};

const fr_settings_feature_job_tracking = /** @type {(inputs: Settings_Feature_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivi d'emploi`)
};

const es_settings_feature_job_tracking = /** @type {(inputs: Settings_Feature_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimiento de empleo`)
};

const it_settings_feature_job_tracking = /** @type {(inputs: Settings_Feature_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracciamento lavori`)
};

const nl_settings_feature_job_tracking = /** @type {(inputs: Settings_Feature_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baantracking`)
};

const pl_settings_feature_job_tracking = /** @type {(inputs: Settings_Feature_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledzenie ofert pracy`)
};

const fi_settings_feature_job_tracking = /** @type {(inputs: Settings_Feature_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työpaikan seuranta`)
};

const da_settings_feature_job_tracking = /** @type {(inputs: Settings_Feature_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobsporing`)
};

const sv_settings_feature_job_tracking = /** @type {(inputs: Settings_Feature_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobbsökning`)
};

/**
* | output |
* | --- |
* | "Job tracking" |
*
* @param {Settings_Feature_Job_TrackingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_feature_job_tracking = /** @type {((inputs?: Settings_Feature_Job_TrackingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Feature_Job_TrackingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_feature_job_tracking(inputs)
	if (locale === "fr") return fr_settings_feature_job_tracking(inputs)
	if (locale === "es") return es_settings_feature_job_tracking(inputs)
	if (locale === "it") return it_settings_feature_job_tracking(inputs)
	if (locale === "nl") return nl_settings_feature_job_tracking(inputs)
	if (locale === "pl") return pl_settings_feature_job_tracking(inputs)
	if (locale === "fi") return fi_settings_feature_job_tracking(inputs)
	if (locale === "da") return da_settings_feature_job_tracking(inputs)
	if (locale === "sv") return sv_settings_feature_job_tracking(inputs)
	return en_settings_feature_job_tracking(inputs)
});